import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'staging',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      photos: z.coerce.number().positive().optional(),
    }),
  },
  {
    name: 'Virtual Staging',
    short: '',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
